import { FeatureFlag } from '../feature-flags/types';
export type UserEntitlementsContext = {
  features: Record<
    string,
    {
      expireTime: number | null;
      linkedPermissions: string[];
      featureFlag?: FeatureFlag;
    }
  >;
  permissions: Record<string, true>;
};

export type EntitlementResult = {
  isEntitled: boolean;
  justification?: NotEntitledJustification;
};

export enum NotEntitledJustification {
  MISSING_FEATURE = 'MISSING_FEATURE',
  MISSING_PERMISSION = 'MISSING_PERMISSION',
  BUNDLE_EXPIRED = 'BUNDLE_EXPIRED',
}

export type CustomAttributes = Record<string, string | number | boolean | Date>;

export type FronteggAttributes = {
  tenantId?: string;
  userId?: string;
  email?: string;
  emailVerified?: boolean;
};

export type Attributes = { custom?: CustomAttributes; jwt?: JwtAttributes };
export type JwtAttributes = Record<string, unknown>;
export const NO_EXPIRATION_TIME = -1;
